import React from 'react';

const Sort = ({ onClose, onSortingSelection }) => {

  const handleSortByChange = (value) => {
    onSortingSelection(value);
    onClose();
  };

  return (

    <div >
      <div className={`border-b border-crimson/20 pb-2 pl-4 pr-14 `}>
        <p
          className="cursor-pointer text-blue-primary hover:text-crimson hover:bg-crimson/5 transition-all duration-300 py-1 px-2 rounded-lg font-medium"
          onClick={() => handleSortByChange('eventTime')}
        >
          Sort by Time
        </p>
      </div>
      <div className={`border-b border-crimson/20 py-2 pl-4 pr-14 `}>
        <p
          className="cursor-pointer text-blue-primary hover:text-crimson hover:bg-crimson/5 transition-all duration-300 py-1 px-2 rounded-lg font-medium"
          onClick={() => handleSortByChange('leagueName')}
        >
          Sort by League
        </p>
      </div>
    </div>
  );
};

export default Sort;
